import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setDataTheme } from "../../../../../core/data/redux/themeSettingSlice";
import styles from './ThemeToggle.module.css';

const ThemeToggle = () => {
    const dispatch = useDispatch();
    const dataTheme = useSelector((state) => state.themeSetting.dataTheme);

    // Determine if we're in dark mode
    const isDarkMode = dataTheme === 'dark-mode';

    const toggleTheme = () => {
        // Toggle between light and dark mode
        const newTheme = isDarkMode ? 'light-mode' : 'dark-mode';
        dispatch(setDataTheme(newTheme));
    };

    return (
        <div className={styles.themeToggle}>
            <button
                className={`${styles.themeButton} ${isDarkMode ? styles.dark : styles.light}`}
                onClick={toggleTheme}
                aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
            >
                {/* Show sun icon in dark mode (click to go to light) */}
                {/* Show moon icon in light mode (click to go to dark) */}
                {isDarkMode ? (
                    <i className="isax isax-sun-1" />
                ) : (
                    <i className="isax isax-moon" />
                )}
            </button>
        </div>
    );
};

export default ThemeToggle;